import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../../features/save/saveSlice";
import {
  fetchBank,
  fetchLeaveType,
  fetchStaffGrade,
} from "../../../../../features/dropdown/dropdownSlice";
import { paymentMethodsData } from "../../../../../data";
import { setSinglePaymentObj } from "../../../../../features/folder/folderSlice";
import VerificationModal from "./VerificationModal";
import PhoneInput from "react-phone-input-2";

const { TextArea } = Input;

const SinglePaymentModal = ({
  open,
  handleCancel,
  handleFetchData,
  setopenSingle,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { bank, staffGradeData, loading } = useSelector(
    (state) => state.dropdown
  );
  const { saving } = useSelector((state) => state.save);
  const { singlePaymentObj } = useSelector((state) => state.folder);

  const [accntNumber, setAccntNumber] = useState();
  const [bankShrtDesc, setBankShrtDesc] = useState();

  const [openVerification, setopenVerification] = useState(false);
  async function handleCancelVerification() {
    await setopenVerification(false);
    await setopenSingle(true);
  }
  async function handleOpenVerification() {
    await setopenVerification(true);
    await setopenSingle(false);
    await handleCancel();
  }

  async function handleCancelSingle() {
    await handleCancel();
    await form.resetFields();
    await setShow();
  }

  const [formData, setFormData] = useState();
  const [show, setShow] = useState(singlePaymentObj?.paymentMethod);

  const [bankCode, setBankCode] = useState();

  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  async function handleValidValidate() {
    if (!bankShrtDesc) {
      toast.error("Please select a bank");
      return;
    }
    if (!accntNumber) {
      toast.error("Please provide a bank number");
      return;
    }
    if (bankShrtDesc && accntNumber) {
      const res = await dispatch(
        save({
          url: `py/verifyAccount.action?bankAccount=${accntNumber}&bankCode=${bankShrtDesc}`,
        })
      );
      if (res?.payload?.success) {
        form.setFieldsValue({
          verifiedReceiverName: res?.payload?.jsonData?.benname,
        });
      } else {
        await form.setFieldsValue({
          verifiedReceiverName: null,
        });
        await toast.error("Account not found type the account name");
      }
    }
  }

  const onFinish = async (data) => {
    // await dispatch(setSinglePaymentObj(data));
    // await handleOpenVerification();
    data.phType = "SINGLE";
    data.pdBankCode = bankCode;
    data.isReceiverNumberVerified = data?.verifiedReceiverName ? 1 : 0;
    const res = await dispatch(
      save({
        ...data,
        url: "py/singlePayment.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await setBankCode("");
      await form.resetFields();
      await setAccntNumber("");
      await setBankShrtDesc("");
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchBankData() {
    dispatch(fetchBank());
  }

  useEffect(() => {
    setShow(singlePaymentObj?.paymentMethod);
  }, [singlePaymentObj?.paymentMethod]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`Single Payment`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancelSingle}
        width={850}
        maskClosable={false}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
          // initialValues={singlePaymentObj}
        >
          <Form.Item
            name="pdTransType"
            className=""
            label={<span>Payment Method</span>}
            rules={[
              {
                required: true,
                message: "Please select payment method",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                paymentMethodsData?.length > 0 &&
                paymentMethodsData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              onChange={(value) => {
                setShow(value);
              }}
              value={formData?.paymentMethod}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {}}
            />
          </Form.Item>
          {show && (
            <>
              <>
                {show === "MPESA" ? (
                  <div className="grid lg:grid-cols-2 lg:gap-x-5 grid-cols-1">
                    <Form.Item
                      name="pdAmount"
                      label="Amount"
                      rules={[
                        {
                          required: true,
                          message: "Enter amount",
                        },
                      ]}
                    >
                      <InputNumber
                        min={0}
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                        parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                        placeholder="Enter amount"
                        className="input flex"
                      />
                    </Form.Item>

                    <Form.Item
                      name="pdReceiverName"
                      label="Receiver Name"
                      rules={[
                        {
                          required: true,
                          message: "Enter receiver name for transfer",
                        },
                      ]}
                    >
                      <Input className="input" />
                    </Form.Item>

                    <Form.Item
                      className="table-form-item"
                      name="pdReceiverNumber"
                      label="Receiver Number"
                      rules={[
                        {
                          required: true,
                          message: "Please add Receiver Number",
                        },
                        {
                          validator: (_, value) => {
                            if (value && value.length === 12) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error(
                                "Phone number must be exactly 10 characters"
                              )
                            );
                          },
                        },
                      ]}
                    >
                      <PhoneInput
                        country="ke"
                        countryCodeEditable={false}
                        className="input"
                      />
                    </Form.Item>

                    <Form.Item
                      extra={"This is optional"}
                      className="table-form-item"
                      name="idNumber"
                      label="National ID"
                      rules={[
                        {
                          required: false,
                          message: "Please add national ID",
                        },
                        {
                          validator(_, value) {
                            if (value && value.toString().length < 6) {
                              return Promise.reject(
                                "National ID must be at least 6 characters long"
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <InputNumber
                        min={0}
                        formatter={(value) => value}
                        parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                        className="input flex"
                      />
                    </Form.Item>
                  </div>
                ) : show === "BANK" ? (
                  <>
                    <div className="flex  lg:flex-row flex-col items-center gap-x-5">
                      <Form.Item
                        name="pdBankName"
                        className="w-full"
                        label={<span>Bank</span>}
                        rules={[
                          {
                            required: true,
                            message: "Please select Bank",
                          },
                        ]}
                      >
                        <Select
                          className=""
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          options={
                            bank?.length > 0 &&
                            bank?.map((item) => ({
                              value: item?.jbnkBankName,
                              label: item?.jbnkBankName,
                            }))
                          }
                          onChange={(selectedBankName) => {
                            const selectedBank = bank?.find(
                              (item) => item?.jbnkBankName === selectedBankName
                            );
                            setBankCode(selectedBank?.jbnkShtDesc);
                            setBankShrtDesc(selectedBank?.jbnkShtDesc);
                          }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label?.toLocaleLowerCase() ?? "").includes(
                              input?.toLocaleLowerCase()
                            )
                          }
                          onDropdownVisibleChange={() => {
                            fetchBankData();
                          }}
                          dropdownRender={(menu) => (
                            <>
                              {loading && (
                                <div
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  <Spin className="sms-spin" />
                                </div>
                              )}
                              {menu}
                            </>
                          )}
                        />
                      </Form.Item>
                      <Form.Item
                        className="w-full"
                        name="pdReceiverNumber"
                        label="Account Number"
                        rules={[
                          {
                            required: true,
                            message: "Please add Account Number",
                          },
                        ]}
                      >
                        <Input
                          className="input"
                          onChange={(e) => {
                            setAccntNumber(e.target.value);
                          }}
                        />
                      </Form.Item>
                      <div className="w-[100px]">
                        <button
                          type="button"
                          className="cstm-btn !rounded-[10px]"
                          disabled={saving}
                          onClick={handleValidValidate}
                        >
                          {saving ? <Spin /> : "Validate"}
                        </button>
                      </div>
                    </div>

                    <Form.Item
                      name="verifiedReceiverName"
                      label="Account Name"
                      rules={[
                        {
                          required: false,
                          message: "Enter Account Name",
                        },
                      ]}
                    >
                      <Input disabled={true} className="input" />
                    </Form.Item>

                    <Form.Item
                      name="pdAmount"
                      label="Amount"
                      rules={[
                        {
                          required: true,
                          message: "Enter amount",
                        },
                      ]}
                    >
                      <InputNumber
                        min={0}
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                        parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                        placeholder="Enter amount"
                        className="input flex"
                      />
                    </Form.Item>
                  </>
                ) : null}
              </>
              <Form.Item
                name="phPaymentDesc"
                label="Reason for transfer"
                rules={[
                  {
                    required: true,
                    message: "Enter reason for transfer",
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  placeholder="Enter reason for transfer"
                  className="input-textarea"
                />
              </Form.Item>
            </>
          )}
          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancelSingle}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
      <VerificationModal
        handleFetchData={handleFetchData}
        open={openVerification}
        setopenVerification={setopenVerification}
        handleCancel={handleCancelVerification}
      />
    </>
  );
};
export default SinglePaymentModal;
